import { actions } from './actions'
import { mutations } from './mutations'
import { state } from './state'

export const projectsFoldersRename = {
  namespaced: true,
  state,
  actions,
  mutations,
}
